// NAIZOR — efecto de celebración en el carrito cuando se desbloquea el envío gratis o el regalo.
// Solo se activa cuando el cliente CRUZA el mínimo (no cuando entra al carrito ya por encima).
// Lee el estado de las barras de nz-free-shipping / nz-free-gift (.nz-ship--done / .nz-gift--done), así que sirve
// igual para el carrito lateral y para la página del carrito, y respeta el umbral de cada mercado (US / Canadá).
(() => {
  if (window.__nzCel) return;
  window.__nzCel = true;

  const KEY = 'nzCelState';
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const COLORS = ['#C9A96A', '#E7D7B1', '#4A6358', '#F3EEE8', '#1E2E28', '#8FA79B'];
  const last = { ship: null, gift: null };
  const pending = { ship: false, gift: false };

  try {
    const saved = JSON.parse(sessionStorage.getItem(KEY) || 'null');
    if (saved) {
      last.ship = saved.ship;
      last.gift = saved.gift;
    }
  } catch (e) {
    /* sin efecto */
  }

  const isVisible = (el) => !!el && el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';

  // Devuelve { el, done, visible } para el tipo pedido, prefiriendo el elemento visible
  function read(selector, doneClass) {
    const all = [...document.querySelectorAll(selector)];
    if (!all.length) return null;
    const el = all.find(isVisible) || all[0];
    return { el, done: el.classList.contains(doneClass), visible: isVisible(el) };
  }

  function burst(el, count) {
    if (reduce || !el) return;
    const host = el.closest('dialog[open]') || document.body;
    const canvas = document.createElement('canvas');
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    const w = window.innerWidth;
    const h = window.innerHeight;
    canvas.width = w * dpr;
    canvas.height = h * dpr;
    canvas.setAttribute('aria-hidden', 'true');
    canvas.style.cssText = `position:fixed;left:0;top:0;width:${w}px;height:${h}px;pointer-events:none;z-index:2147483000;`;
    host.appendChild(canvas);
    const ctx = canvas.getContext('2d');
    ctx.scale(dpr, dpr);
    const cr = canvas.getBoundingClientRect();
    const r = el.getBoundingClientRect();
    const ox = r.left - cr.left + Math.min(r.width, 320) * 0.5;
    const oy = r.top - cr.top + r.height * 0.4;
    const parts = Array.from({ length: count }, () => {
      const a = -Math.PI / 2 + (Math.random() - 0.5) * Math.PI * 1.15;
      const v = 5 + Math.random() * 9;
      return {
        x: ox + (Math.random() - 0.5) * 60,
        y: oy,
        vx: Math.cos(a) * v,
        vy: Math.sin(a) * v,
        s: 4 + Math.random() * 5,
        rot: Math.random() * Math.PI,
        vr: (Math.random() - 0.5) * 0.4,
        c: COLORS[(Math.random() * COLORS.length) | 0],
        round: Math.random() < 0.35,
      };
    });
    const t0 = performance.now();
    (function frame(now) {
      const t = now - t0;
      ctx.clearRect(0, 0, w, h);
      const fade = t > 1700 ? Math.max(0, 1 - (t - 1700) / 500) : 1;
      parts.forEach((p) => {
        p.vy += 0.28;
        p.vx *= 0.992;
        p.x += p.vx;
        p.y += p.vy;
        p.rot += p.vr;
        ctx.save();
        ctx.globalAlpha = fade;
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.fillStyle = p.c;
        if (p.round) {
          ctx.beginPath();
          ctx.arc(0, 0, p.s / 2, 0, Math.PI * 2);
          ctx.fill();
        } else {
          ctx.fillRect(-p.s / 2, -p.s / 3, p.s, p.s * 0.66);
        }
        ctx.restore();
      });
      if (t < 2200) requestAnimationFrame(frame);
      else canvas.remove();
    })(t0);
  }

  function play(type, el) {
    const gift = type === 'gift';
    el.classList.remove('nz-cel-pop');
    void el.offsetWidth; // reinicia la animación
    el.classList.add('nz-cel-pop');
    setTimeout(() => el.classList.remove('nz-cel-pop'), 1600);
    burst(el, gift ? 70 : 34);
  }

  function check() {
    const now = {
      ship: read('.nz-ship', 'nz-ship--done'),
      gift: read('.nz-gift:not(.nz-gift--code)', 'nz-gift--done'),
    };
    ['ship', 'gift'].forEach((type) => {
      const cur = now[type];
      if (!cur) return;
      if (last[type] === null) {
        last[type] = cur.done; // primera lectura: no se celebra
      } else if (cur.done && !last[type]) {
        pending[type] = true;
        last[type] = true;
      } else if (!cur.done) {
        last[type] = false;
        pending[type] = false;
      }
      if (pending[type] && cur.visible) {
        pending[type] = false;
        play(type, cur.el);
      }
    });
    try {
      sessionStorage.setItem(KEY, JSON.stringify({ ship: last.ship, gift: last.gift }));
    } catch (e) {
      /* sin efecto */
    }
  }

  let timer;
  const schedule = () => {
    clearTimeout(timer);
    timer = setTimeout(check, 150);
  };
  new MutationObserver(schedule).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['open', 'class'],
  });
  document.addEventListener('DOMContentLoaded', schedule);
  schedule();

  // Para probar a mano en la consola: window.nzCelebrate('gift')
  window.nzCelebrate = (type) => {
    const el = document.querySelector(type === 'ship' ? '.nz-ship' : '.nz-gift');
    if (el) play(type === 'ship' ? 'ship' : 'gift', el);
  };
})();
